import React from 'react';
import { ArrowLeft, Check, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';

const ServiceInterieur = () => {
  const navigate = useNavigate();

  const interiorFormulas = [
    {
      id: 1,
      name: "Formule Basse",
      price: "70€",
      services: [
        "Aspiration intérieur + coffre",
        "Dépoussiérage des plastiques"
      ]
    },
    {
      id: 2,
      name: "Formule Standard",
      price: "110€",
      services: [
        "Aspiration habitacle + coffre",
        "Dépoussiérage des plastiques",
        "Nettoyage des plastiques"
      ]
    },
    {
      id: 3,
      name: "Formule Premium",
      price: "150€",
      popular: true,
      services: [
        "Aspiration habitacle + coffre",
        "Dépoussiérage des plastiques",
        "Nettoyage des plastiques",
        "Nettoyage des surfaces vitrées",
        "Parfumation"
      ]
    },
    {
      id: 4,
      name: "Formule Haut de Gamme",
      price: "220€",
      services: [
        "Aspiration habitacle + coffre",
        "Dépoussiérage des plastiques",
        "Nettoyage des plastiques",
        "Nettoyage des surfaces vitrées",
        "Shampoing des sièges, des tapis et des sols",
        "Désinfection à la vapeur (sols/tapis/rails)",
        "Nettoyage des poils d'animaux inclus",
        "Parfumation"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-gray-700 hover:text-blue-600"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-100 to-blue-200 py-16">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-center text-gray-900 mb-4">
            Détailing Intérieur
          </h1>
          <p className="text-xl text-center text-gray-600 max-w-3xl mx-auto">
            Du nettoyage basique au service complet haut de gamme pour un intérieur impeccable
          </p>
        </div>
      </section>

      {/* Interior Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Formules INTÉRIEUR</h2>
            <p className="text-lg text-gray-600">Choisissez la formule adaptée à vos besoins</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {interiorFormulas.map((formula) => (
              <Card
                key={formula.id}
                className={`relative ${formula.popular ? 'border-4 border-blue-500 shadow-2xl transform scale-105' : 'border-2 border-gray-200'}`}
              >
                {formula.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-blue-500 text-white px-4 py-1 rounded-full font-bold text-xs shadow-lg">
                      ⭐ RECOMMANDÉ
                    </span>
                  </div>
                )}
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{formula.name}</h3>
                  <div className="text-3xl font-bold text-blue-600 mb-6">{formula.price}</div>
                  <ul className="space-y-2">
                    {formula.services.map((service, index) => (
                      <li key={index} className="flex items-start">
                        <Check className="w-4 h-4 text-blue-600 mr-2 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-700">{service}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-500 to-blue-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Offrez à votre véhicule un intérieur comme neuf !
          </h2>
          <p className="text-xl text-white mb-8">
            Contactez-nous pour réserver votre formule de détailing intérieur
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              size="lg"
              className="bg-white text-gray-900 hover:bg-gray-100 font-semibold text-lg px-8 py-6"
              onClick={() => navigate('/?devis=interieur')}
            >
              Demander un Devis
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold text-lg px-8 py-6"
              onClick={() => window.location.href = 'tel:0661994139'}
            >
              Appeler : 06.61.99.41.39
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceInterieur;
